// src/utils/apiHelpers.js

/**
 * Extract data from API response based on your backend structure
 */
export const extractData = (response) => {
    // Handle success: true, message: 'Success', data: {...}
    if (response.success && response.data) {
      return response.data;
    }
    
    // Handle direct data response
    if (response.data) {
      return response.data;
    }
    
    // Return the response as-is if structure is different
    return response;
  };
  
  /**
   * Extract list data with pagination
   */
  export const extractListData = (response) => {
    const data = extractData(response);
    
    return {
      items: data.disputes || data.tickets || data.data || data.items || data || [],
      pagination: data.pagination || {}
    };
  };
  
  /**
   * Extract single item data
   */
  export const extractItemData = (response) => {
    const data = extractData(response);
    
    return {
      item: data.dispute || data.ticket || data.item || data,
      attachments: data.attachments || data.evidence || [],
      dispute: data.dispute || null,
      order: data.order || null,
      evidence: data.evidence || [],
      messages: data.messages || []
    };
  };
  
  export default {
    extractData,
    extractListData,
    extractItemData
  };